<template>
  <div class="ni-app-footer-wrapper columns is-centered is-half">
    &copy; {{ currentYear }} Thermo Fisher Scientific Inc. All Rights Reserved
  </div>
</template>

<script>
export default {
  name: "NewItemAppFooter",
  data: function() {
    return {
      currentYear: (this.currentYear = new Date().getFullYear().toString())
    };
  }
};
</script>

<style scoped></style>
